import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../../providers/ApiProvider';

export function useBusinessVerification({
  code,
  enabled = true,
}: {
  code: string;
  enabled?: boolean;
}) {
  const api = useApi();

  return useQuery({
    queryKey: ['business-merchant', 'documentation', code], 
    queryFn: async () => {
      const res = await api.GET({
        endpoint: `business-merchant/${code}/documentation`,
      });
      return res;
    },
    enabled,
  });
}
